import clsx from 'clsx'
import Image from 'next/image'
import { useTranslations } from 'next-intl'

import S from '../ClubProfileAnalytics.module.scss'

interface BlockStateProps {
  /** Empty copy; ignored for an error, which has its own. */
  title?: string
  description?: string
  error?: boolean
  onRetry?: () => void
  large?: boolean
}

/** A block without data (no fans yet) or failed to load (design states). */
const BlockState = ({
  title,
  description,
  error = false,
  onRetry,
  large = false
}: BlockStateProps) => {
  const t = useTranslations('club.stats')
  const size = large ? 96 : 48

  return (
    <div
      className={clsx(S.blockState, large && S.blockStateLarge)}
      role={error ? 'alert' : undefined}
    >
      <Image
        src={`/assets/club-profile/analytics-${error ? 'error' : 'empty'}.png`}
        alt=""
        width={size}
        height={size}
      />
      <p className={S.blockStateTitle}>
        {error ? t('analytics.errorTitle') : title}
      </p>
      <p className={S.blockStateText}>
        {error ? t('analytics.errorText') : description}
      </p>
      {error && onRetry ? (
        <button type="button" className={S.retry} onClick={onRetry}>
          {t('retry')}
        </button>
      ) : null}
    </div>
  )
}

export default BlockState
